import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TAccountClient, TAccountClientUpdate, TAccountClientResponse, adaptAccountClientFromResponse, adaptAccountClientToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_CLIENT } from '../../backend-paths';


export const accountClientUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ACCOUNT_CLIENT}/:id`,
	(payload: TAccountClientUpdate, thunkApi) => {
		const { data, id } = payload;
		const path = `${BACKEND_ACCOUNT_CLIENT}/${id}`;
		const dataRequest = adaptAccountClientToRequest(data);

		return HttpService.put<TAccountClientResponse>(path, dataRequest).then(result => {
			return adaptAccountClientFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TAccountClient> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountClientUpdateSlice = createSlice({
	name: 'accountClientUpdateSlice',
	initialState,
	reducers: {
		clearAccountClientUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountClientUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountClientUpdateApi.fulfilled.type]: (state, action: PayloadAction<TAccountClient>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountClientUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountClientUpdateSelector = () => useAppSelector(state => state[accountClientUpdateSlice.name]);

export const { clearAccountClientUpdate } = accountClientUpdateSlice.actions;
